import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import CardsEntretenimento from '../../componentes/comuns/CardsEntretenimento';
import HelpSection from '../../componentes/comuns/HelpSection';


const Entretenimento = () => {
    return (

        <>
            <Header />
            <main>
                <CardsEntretenimento />
                <div>
                    <HelpSection />
                </div>
            </main>
            <Footer />
        </>
    );
}

export default Entretenimento;